import React from "react";
import { FaCheckCircle, FaMinus } from "react-icons/fa";

// "~" = available with limitations (renders as a note)
// true  = full check
// false = dash (not included)

const managementFeatures = [
    { name: "Manage workspaces",                                                                                   values: [true,  true,  true]  },
    { name: "Team collaboration (up to 5 users)",                                                                  values: [true,  false, false] },
    { name: "Team collaboration (up to 15 users)",                                                                 values: [false, true,  true]  },
    { name: "2GB files & photo storage",                                                                           values: [true,  false, false] },
    { name: "Unlimited files & photo storage",                                                                     values: [false, true,  true]  },
    { name: "Up to 5 meeting scheduling",                                                                          values: [true,  false, false] },
    { name: "Unlimited scheduling & meetings",                                                                     values: [false, true,  true]  },
    { name: "Access to basic AI",                                                                                  values: [true,  true,  true]  },
    { name: "Subcontractors & consultants in projects",                                                            values: [false, true,  true]  },
    { name: "Project codes allocated to the project",                                                              values: [true,  true,  true]  },
    { name: "Compliance tracking and inspection management",                                                       values: [false, false, true]  },
    { name: "API access and integration",                                                                          values: [false, false, true]  },
    { name: "Dedicated account manager",                                                                           values: [false, false, true]  },
    { name: "24/7 support",                                                                                        values: [false, false, true]  },
];

const MANAGEMENT_PLAN_HEADERS = ["Basic", "Standard", "Enterprise"];

const publishingFeatures = [
    { name: "Public profile + your ConRa code",                                                                    values: [true,  true,  true]  },
    { name: "Listed & findable in global search",                                                                  values: [true,  true,  true]  },
    { name: "C2PA verified — cryptographically signed, tamper-proof",                                              values: [true,  true,  true]  },
    { name: "Bank-grade security",                                                                                 values: [true,  true,  true]  },
    { name: "Accessible anywhere: mobile, desktop, web",                                                          values: [true,  true,  true]  },
    { name: "Location-locked, sealed project verification",                                                        values: [false, true,  true]  },
    { name: "Unique project code (e.g. Knights KN210)",                                                            values: [false, true,  true]  },
    { name: "Publish milestones & innovations",                                                                    values: [false, true,  true]  },
    { name: "Automatic notifications to bookmarked followers",                                                     values: [false, true,  true]  },
    { name: "Generous bookmark limit — no per-follower charges",                                                   values: [false, true,  true]  },
    { name: "Record stays viewable after cancellation",                                                            values: [false, true,  true]  },
    { name: "Billing auto-pauses after 60+ days of no logged progress",                                           values: [false, true,  true]  },
    { name: "Direct API connections & webhook streams",                                                            values: [false, false, true]  },
    { name: "Integrates into your existing CRM or property system as-is",                                         values: [false, false, true]  },
    { name: "Unlimited bookmarks & milestone broadcasting at scale",                                              values: [false, false, true]  },
    { name: "Multi-tier portfolio monitoring & analytics",                                                         values: [false, false, true]  },
    { name: "Secure project admin controls & role permissions",                                                    values: [false, false, true]  },
    { name: "Dedicated solution architecture support",                                                             values: [false, false, true]  },
    { name: "10-year proof retention",                                                                             values: [false, false, true]  },
];

const PUBLISHING_PLAN_HEADERS = ["Free", "Standard", "Enterprise"];

const Cell = ({ value }) => {
    if (value === true)  return <FaCheckCircle className="ctable-check" />;
    if (value === false) return <FaMinus className="ctable-dash" />;
    if (value === "~")   return <span className="ctable-partial">~</span>;
    return <span className="ctable-text">{value}</span>;
};

const ComparePlans = ({ activeTab }) => {
    const isPublishing = activeTab !== "management";
    const features = isPublishing ? publishingFeatures : managementFeatures;
    const planHeaders = isPublishing ? PUBLISHING_PLAN_HEADERS : MANAGEMENT_PLAN_HEADERS;

    return (
        <section id="price-compare">
            <div className="compare-plans">
                <div className="table-scroll">
                    <table>
                        <thead>
                            <tr>
                                <th className="ctable-feature-col">Compare Plans</th>
                                {planHeaders.map((plan, i) => (
                                    <th
                                        key={i}
                                        className={`plan-header ${plan === "Standard" ? "ctable-featured-header" : ""}`}
                                    >
                                        {plan}
                                    </th>
                                ))}
                            </tr>
                        </thead>
                        <tbody>
                            {features.map((feature, index) => (
                                <tr key={index}>
                                    <td className="ctable-feature-name">{feature.name}</td>
                                    {feature.values.map((value, idx) => (
                                        <td key={idx}>
                                            <Cell value={value} />
                                        </td>
                                    ))}
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
        </section>
    );
};

export default ComparePlans;
